import { render, staticRenderFns } from "./input4Model.vue?vue&type=template&id=52164945"
import script from "./input4Model.vue?vue&type=script&lang=js"
export * from "./input4Model.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports